<script lang="ts">
  import { api } from '$shared/api';
  import LoadingSkeleton from '$shared/LoadingSkeleton.svelte';

  interface ListenEntry {
    id: number;
    track_id: number;
    track_name: string;
    track_username: string;
    duel_id: number;
    duel_name: string;
    listened_at: string;
  }

  let listens = $state<ListenEntry[]>([]);
  let loading = $state(true);

  $effect(() => {
    api
      .get<{ listens: ListenEntry[] }>('/users/current/listens')
      .then((d) => {
        listens = d.listens || [];
        loading = false;
      })
      .catch((e: unknown) => {
        console.error('Failed to load listen history:', e);
        loading = false;
      });
  });
</script>

<div>
  <h1>Listen History</h1>
  {#if loading}
    <LoadingSkeleton lines={6} />
  {:else if listens.length === 0}
    <p class="empty">You haven't listened to any tracks yet.</p>
  {:else}
    <div class="listen-list">
      {#each listens as listen}
        <div class="listen-row">
          <div class="listen-info">
            <a href="#/tracks/{listen.track_id}" class="listen-track">{listen.track_name || 'Untitled'}</a>
            <div class="listen-meta">
              by <span class="listen-artist">{listen.track_username}</span>
              in <a href="#/duels/{listen.duel_id}/leaderboard">{listen.duel_name}</a>
            </div>
          </div>
          <span class="listen-date">{new Date(listen.listened_at).toLocaleDateString()}</span>
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  h1 {
    margin-bottom: 1.5rem;
  }
  .empty {
    color: var(--text-secondary);
  }
  .listen-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .listen-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.75rem;
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius);
  }
  .listen-info {
    flex: 1;
    min-width: 0;
  }
  .listen-track {
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .listen-track:hover {
    color: var(--cyan);
  }
  .listen-meta {
    margin-top: 0.25rem;
    font-size: 0.8125rem;
    color: var(--text-secondary);
  }
  .listen-meta a:hover {
    color: var(--cyan);
  }
  .listen-artist {
    color: var(--text);
  }
  .listen-date {
    font-size: 0.75rem;
    color: var(--text-muted);
    white-space: nowrap;
  }
</style>
